import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { raceCancellation } from 'vscode/vscode/vs/base/common/async';
import { CancellationTokenSource } from 'vscode/vscode/vs/base/common/cancellation';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { IProgressService } from 'vscode/vscode/vs/platform/progress/common/progress.service';
import { Disposable, toDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { insert } from 'vscode/vscode/vs/base/common/arrays';

const _moduleId = "vs/workbench/services/workingCopy/common/storedFileWorkingCopySaveParticipant";
let StoredFileWorkingCopySaveParticipant = class StoredFileWorkingCopySaveParticipant extends Disposable {
    get length() { return this.saveParticipants.length; }
    constructor(progressService, logService) {
        super();
        this.progressService = progressService;
        this.logService = logService;
        this.saveParticipants = [];
    }
    addSaveParticipant(participant) {
        const remove = insert(this.saveParticipants, participant);
        return toDisposable(() => remove());
    }
    participate(workingCopy, context, token) {
        const cts = ( (new CancellationTokenSource(token)));
        return this.progressService.withProgress({
            title: ( localizeWithPath(_moduleId, 0, "Saving '{0}'", workingCopy.name)),
            location: 15 ,
            cancellable: true,
            delay: workingCopy.isDirty() ? 3000 : 5000
        }, async (progress) => {
            workingCopy.model?.pushStackElement();
            for (const saveParticipant of this.saveParticipants) {
                if (cts.token.isCancellationRequested || workingCopy.isDisposed()) {
                    break;
                }
                try {
                    const promise = saveParticipant.participate(workingCopy, context, progress, cts.token);
                    await raceCancellation(promise, cts.token);
                }
                catch (err) {
                    this.logService.warn(err);
                }
            }
            workingCopy.model?.pushStackElement();
            cts.dispose();
        }, () => {
            cts.dispose(true);
        });
    }
    dispose() {
        this.saveParticipants.splice(0, this.saveParticipants.length);
        super.dispose();
    }
};
StoredFileWorkingCopySaveParticipant = ( (__decorate([
    ( (__param(0, IProgressService))),
    ( (__param(1, ILogService)))
], StoredFileWorkingCopySaveParticipant)));

export { StoredFileWorkingCopySaveParticipant };
